/*LIBRARY*/
import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";

/*PAGES*/
import BLOG_LIST_VIEWER from "../Pages/blog/BLOG_LIST_VIEWER";
import DOWNLOAD_ALL from "../Pages/blog/DOWNLOAD_ALL";

/*COMPONENT*/
import ErrorBoundary from "./ErrorHandler/ErrorBoundary";
import ErrorUI from "./ErrorHandler/ErrorUI";
import { ErrorProvider } from "./ErrorHandler/ErrorContext";
import ErrorUIBoundary from "./ErrorHandler/ErrorUIBoundary";
import NotFoundPage from "../Pages/dashboard/NotFoundPage";

/*REDUX*/

/*FUNCTION*/
import store from "./store";

/*CSS*/
import "../Style/color.css";
import "../Style/container.css";
import "../Style/main_tag.css";
import "../Style/shape.css";
import "../Style/variable.css";
import "../Style/draft_js.css";
import "../Style/blog.css";

/*CONST*/

const App = () => {
  useEffect(() => {
    const handleWheel = (e) => {
      const active = document.activeElement;
      if (
        active &&
        active.type === "number" &&
        active === document.activeElement
      ) {
        e.preventDefault();
      }
    };

    window.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      window.removeEventListener("wheel", handleWheel);
    };
  }, []);

  const helmetContext = {};

  return (
    <Provider store={store}>
      <HelmetProvider context={helmetContext}>
        <ErrorProvider>
          <ErrorBoundary fallback={<ErrorUIBoundary />}>
            <div>
              <Routes>
                {/* 1. Home Page */}
                <Route path="/docs" element={<BLOG_LIST_VIEWER />} />

                {/* 2. Static Routes (Must come BEFORE /:slug) */}
                <Route path="/docs/download_all" element={<DOWNLOAD_ALL />} />

                {/* 3. Dynamic Blog Pages (e.g. domain.com/getting-started) */}
                <Route path="/docs/:slug" element={<BLOG_LIST_VIEWER />} />

                {/* 4. 404 */}
                <Route path="*" element={<NotFoundPage />} />
              </Routes>

              <style>{`
                  #startingLoader { 
                    display: none;
                  }
                  body {
                    transition: opacity 0.3s ease-in-out;
                  }
                `}</style>
            </div>
            <ErrorUI />
          </ErrorBoundary>
        </ErrorProvider>
      </HelmetProvider>
    </Provider>
  );
};

export default App;
